import React from 'react'
import { Switch } from '@ztechapps/webui.util'
import { DateValue } from './DateValue'
import { DynamicValue } from './DynamicValue'
import { useContext } from './Context'
import { TypeValue } from './TypeValue'
import { Stack } from 'react-bootstrap'

export const Layout = () => {
  const { valueType } = useContext()
  return (
    <div className="py-2" style={{ width: 600 }}>
      <Stack gap={1}>
        <TypeValue />
        <Switch expression={valueType}>
          {{
            date: <DateValue />,
            dynamic: <DynamicValue />,
          }}
        </Switch>
      </Stack>
    </div>
  )
}
